import React from 'react';
import type { FC } from 'react';
import { styled } from '@material-ui/core';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import { theme } from '@/theme/mui-theme';

const StyledContainer = styled('div')({
  display: 'flex',
  color: 'rgba(0, 0, 0, 0.38)',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: theme.spacing(1),
  fontSize: '16px'
});

const SidebarEmptyResult : FC = () => {
  return (
    <StyledContainer>
      <FindInPageIcon />

      No result found
    </StyledContainer>
  );
};

export default SidebarEmptyResult;
